namespace Ir.Components.General.DateTime {

    interface IViewModel {
        textBoxConfig: DevExpress.ui.dxTextBox.Properties;
    }
    export interface IDateTimeParams {
        dateTime: KnockoutObservable<string> | string;
        width: string;
    }

    export function getViewModel(this: IViewModel, params: IDateTimeParams, componentInfo) {

        let dateTime = typeof params.dateTime === "function" ? params.dateTime : ko.observable(params.dateTime)
        let dateTimeFormatted = ko.computed(function () {
            return formatDateTime(dateTime());
        })
        this.textBoxConfig = {
            value: dateTimeFormatted as any,
            width: params.width ?? "100%",
            stylingMode: 'underlined',
            readOnly: true
        };
    }
}